export default "__VITE_ASSET__DCjR_3Dj__"